import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';

const GetCanBeLinkedToSpruce = graphql(`
  query GetCanBeLinkedToSpruce($projectId: ID!) {
    projectById(id: $projectId) {
      canBeLinkedToSpruce {
        result
        reasons {
          code
          message
        }
      }
    }
  }
`);

const useGetCanBeLinkedToSpruce = (
  projectId: string,
  options?: { enabled?: boolean }
) => {
  const { data, ...rest } = useQuery({
    enabled: options?.enabled ?? true,
    queryKey: projectKeys.canBeLinkedToSpruce(projectId),
    queryFn: () => gqlClient.request(GetCanBeLinkedToSpruce, { projectId }),
  });

  return {
    spruceAvailability: data?.projectById.canBeLinkedToSpruce,
    data,
    ...rest,
  };
};

export default useGetCanBeLinkedToSpruce;
